var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 700,
    viewBox: "0 0 1152 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.906 587.094L345.5 584L344.094 587.094L341 588.5L344.094 589.906L345.5 593L346.906 589.906L350 588.5L346.906 587.094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M558.906 263.094L557.5 260L556.094 263.094L553 264.5L556.094 265.906L557.5 269L558.906 265.906L562 264.5L558.906 263.094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M687.906 136.094L686.5 133L685.094 136.094L682 137.5L685.094 138.906L686.5 142L687.906 138.906L691 137.5L687.906 136.094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M952.906 397.094L951.5 394L950.094 397.094L947 398.5L950.094 399.906L951.5 403L952.906 399.906L956 398.5L952.906 397.094Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.906 323.094L109.5 320L108.094 323.094L105 324.5L108.094 325.906L109.5 329L110.906 325.906L114 324.5L110.906 323.094Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 60.0938L17.5 57L16.0938 60.0938L13 61.5L16.0938 62.9062L17.5 66L18.9062 62.9062L22 61.5L18.9062 60.0938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars2);
export default __webpack_public_path__ + "static/media/stars2.7eca87e8f59a2d5975515ec0c66d4b04.svg";
export { ForwardRef as ReactComponent };